export const getCornasData = () => ({
  name: "Cornas",
  region: "Rhône",
  country: "France",
  description: "Cornas est une appellation prestigieuse du Rhône septentrional, produisant exclusivement des vins rouges puissants et structurés avec le cépage Syrah.",
  type: "subregion",
  area: "120 ha",
  production: "4,000 hectolitres",
  mapAreas: [
    { region: "Cornas", x: 53, y: 67, color: "#4B164C", size: 3 }
  ],
  characteristics: {
    climate: "Climat continental avec influence méditerranéenne",
    soil: "Sols de granit, schiste et micaschiste",
    viticulture: "Viticulture en terrasses, vendanges manuelles, rendements très limités"
  },
  wineStyles: {
    red: "Vins rouges puissants et structurés, avec des notes de fruits noirs et d'épices"
  },
  history: "Cornas produit des vins depuis l'époque romaine. L'appellation est reconnue depuis 1938. Cornas est l'une des rares appellations du Rhône à ne produire que des vins rouges.",
  foodPairing: "Viandes rouges, gibier, fromages affinés, cuisine gastronomique",
  grapeVarieties: [
    {
      name: "Syrah",
      percentage: "100%",
      description: "Cépage unique de Cornas, produisant des vins rouges puissants et structurés",
      characteristics: "Puissant, structuré, tanins fermes, notes de fruits noirs et d'épices",
      wineStyles: "Sec, plein-corps, tannique"
    }
  ]
}); 